/* eslint-disable import/prefer-default-export */

export const desktopNavHeight = 60;
